import React from 'react'

import { P } from '@frame/ui-primitives/p'

import { useStore } from '@frame/lib/stores/useStore'
import { IncomeType } from '@frame/lib/types'
import { DataAttribute } from '@frame/types'

import { UPLOAD_STEP_CONFIG } from '../constants'

type Props = {
  incomeType: IncomeType
  useAsHeader?: boolean
}

export function UploadStepContent({ incomeType, useAsHeader = false }: Props) {
  const { docsUploadScreenCopy } = useStore(({ session }) => ({
    docsUploadScreenCopy: session?.configuration.settings?.docs_upload_screen_copy ?? undefined,
  }))
  const {
    desc: { plain, bold = [] },
  } = docsUploadScreenCopy
    ? {
        desc: {
          plain: docsUploadScreenCopy,
        },
      }
    : UPLOAD_STEP_CONFIG[incomeType]
  const splitText = plain.split(new RegExp(`(${bold.join('|')})`, 'g'))

  if (useAsHeader && splitText && splitText.length > 0) {
    return <>{splitText}</>
  }

  const descWithBoldedText = splitText.map((text) => {
    if (bold.includes(text)) {
      return (
        <span key={text} className="font-semibold">
          {text}
        </span>
      )
    }

    return text
  })

  return (
    <div data-cy={DataAttribute.UPLOAD_STEP_CONTENT}>
      <P className="mb-2">{descWithBoldedText}</P>
    </div>
  )
}
